import { LegalPage } from "@/components/legal/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Terms() {
  return (
    <LegalPage title="Termeni și condiții" updated="iunie 2026">
      <h2>1. Informații despre vânzător</h2>
      <p>
        Website-ul <strong>{COMPANY.brand}</strong> este administrat de <strong>{COMPANY.legalName}</strong>,
        CUI <strong>{COMPANY.cui}</strong>, nr. de înregistrare <strong>{COMPANY.regNo}</strong>.
        Date de contact: telefon {COMPANY.phone}, e-mail {COMPANY.email}.
      </p>
      <p>
        Prin utilizarea acestui website și plasarea unei comenzi, sunteți de acord cu prezentii Termeni și
        condiții. Vă rugăm să îi citiți cu atenție.
      </p>

      <h2>2. Produse și prețuri</h2>
      <p>
        Toate prețurile afișate sunt exprimate în lei (RON) și includ TVA acolo unde este aplicabil.
        Ne rezervăm dreptul de a modifica prețurile și disponibilitatea produselor în orice moment, fără notificare prealabilă.
        Imaginile produselor au caracter informativ și pot diferi ușor de produsele livrate.
      </p>

      <h2>3. Plasarea și confirmarea comenzii</h2>
      <p>
        Comanda se plasează online prin adăugarea produselor în coș și completarea datelor de livrare, sau telefonic
        la numărul {COMPANY.phone}. După plasarea comenzii veți primi o confirmare. Contractul de vânzare se consideră
        încheiat în momentul confirmării comenzii de către vânzător.
      </p>

      <h2>4. Modalitate de plată</h2>
      <p>
        Plata se efectuează prin <strong>ramburs (plata la livrare)</strong> — achitați curierului suma la primirea coletului.
      </p>

      <h2>5. Livrare</h2>
      <p>
        Livrarea se realizează prin curier, în general în 1-2 zile lucrătoare de la confirmarea comenzii.
        Transportul este <strong>gratuit pentru toate comenzile</strong>, indiferent de valoare.
      </p>

      <h2>6. Dreptul de retragere (retur)</h2>
      <p>
        Conform O.U.G. nr. 34/2014, consumatorul are dreptul de a se retrage din contract, fără invocarea vreunui motiv,
        în termen de <strong>14 zile calendaristice</strong> de la primirea produselor. Detalii complete găsiți în
        <strong> Politica de retur</strong>.
      </p>

      <h2>7. Garanție și conformitate</h2>
      <p>
        Produsele beneficiază de garanția legală de conformitate conform legislației în vigoare. Pentru orice
        neconformitate constatată, ne puteți contacta la {COMPANY.email} sau {COMPANY.phone}.
      </p>

      <h2>8. Protecția datelor</h2>
      <p>
        Prelucrăm datele dumneavoastră cu caracter personal conform Regulamentului (UE) 2016/679 (GDPR).
        Detalii în <strong>Politica de confidențialitate</strong>.
      </p>

      <h2>9. Soluționarea litigiilor</h2>
      <p>
        Eventualele litigii pot fi soluționate pe cale amiabilă sau prin intermediul platformelor puse la dispoziție
        de A.N.P.C.: Soluționarea Alternativă a Litigiilor (SAL) — <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">anpc.ro/ce-este-sal</a>
        și platforma europeană SOL — <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">ec.europa.eu/consumers/odr</a>.
      </p>

      <h2>10. Contact</h2>
      <p>
        {COMPANY.legalName} · CUI {COMPANY.cui} · Nr. înreg. {COMPANY.regNo} · Tel: {COMPANY.phone} · E-mail: {COMPANY.email}
      </p>
    </LegalPage>
  );
}
